export function OtpModel() {
    this.contactNumber = null;
    this.otp = null;
    this.refcode = null;
    this.channel = null;

    this.setContactNumber = function (contactNumber) {
        this.contactNumber = contactNumber;
        return this;
    };
    this.setOtp = function (otp) {
        this.otp = otp;
        return this;
    };
    this.setRefcode = function (refcode) {
        this.refcode = refcode;
        return this;
    };
    this.setChannel = function (channel) {
        this.channel = channel;
        return this;
    };

    this.setFromModel = function (otpModel) {
        this.contactNumber = otpModel.contactNumber;
        this.otp = otpModel.otp;
        this.refcode = otpModel.refcode;
        this.channel = otpModel.channel;
    };
}
